export const login = function ({ dispatch, commit }, payload) {
  commit("setToken", null);
  const data = {};
  data.url = "login";
  data.method = "POST";
  data.loading = "inloggen";
  data.data = payload;
  return dispatch("axiosWeb", data, { root: true })
    .then((response) => {
      commit("setUser", response.data);

      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const logout = function ({ dispatch, commit }) {
  commit("setToken", null);
  commit("setUser", {});
  const data = {};
  data.url = "logout";
  data.method = "POST";
  data.loading = "uitloggen";
  return dispatch("axiosWeb", data, { root: true })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const resetPassword = function ({ dispatch, commit }, payload) {
  const data = {};
  data.url = "resetpassword";
  data.method = "POST";
  data.loading = "sendingresetpasswordemail";
  data.data = payload;
  return dispatch("axiosWeb", data, { root: true })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const changePassword = function ({ dispatch, commit }, payload) {
  const data = {};
  data.url = "change-password-with-token";
  data.method = "POST";
  data.loading = "changingpassword";
  data.data = payload;
  return dispatch("axiosWeb", data, { root: true })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const validatingcode = function ({ dispatch, commit }, payload) {
  const data = {};
  data.url = "validate-2fa-code";
  data.method = "POST";
  data.loading = "validatingcode";
  data.data = payload;
  return dispatch("axiosWeb", data, { root: true })
    .then((response) => {
      commit("setToken", response.data);
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getTokenBeforeMount = function (
  { state, dispatch, commit },
  payload
) {
  commit("setQueuedActions", payload);
  if (state.token === "REQUESTING") {
    return;
  }

  if (state.token === undefined) {
    commit("setToken", "REQUESTING");
    return dispatch("getLoggedInUser").then(() => {
      while (state.queuedActions.length > 0) {
        dispatch(state.queuedActions[0], "", { root: true });
        commit("removeActionFromQueue");
      }
    });
  } else {
    while (state.queuedActions.length > 0) {
      dispatch(state.queuedActions[0], "", { root: true });
      commit("removeActionFromQueue");
    }
  }
};

export const getAdminSettings = function ({ dispatch, commit }, payload) {
  const data = {};
  data.url = "get-admin-settings";
  data.method = "GET";
  data.loading = "gettingsettings";
  return dispatch("axiosWeb", data, { root: true })
    .then((response) => {
      commit("setAdminSettings", response.data);
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getLoggedInUser = function ({ dispatch, commit }) {
  const data = {};
  data.url = "get-logged-in-user";
  data.method = "GET";
  data.loading = "gettingsettings";
  return dispatch("axiosWeb", data, { root: true })
    .then((response) => {
      commit("setUser", response.data.user);
      commit("setToken", response.data.token);
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getLoggedInUserWithoutError = function ({ dispatch, commit }) {
  const data = {};
  data.url = "get-logged-in-user-without-error";
  data.method = "GET";
  data.loading = "gettingsettings";
  return dispatch("axiosWeb", data, { root: true })
    .then((response) => {
      commit("setUser", response.data.user);
      commit("setToken", response.data.token);
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const clearLoginData = function ({ commit }) {
  commit("setUser", {});
  commit("setToken", null);
  commit("setLoginToken", null);
  commit("clearQueuedActions");
};

export const resend2faEmail = function ({ dispatch, state, commit }) {
  const data = {};
  data.url = "resend-2fa-email";
  data.method = "POST";
  data.loading = "validatingcode";
  data.data = { user: state.user };
  return dispatch("axiosWeb", data, { root: true })
    .then((response) => {
      if (response.data.user) {
        commit("setUser", response.data.user);
      }
      if (response.data.token) {
        commit("setToken", response.data.token);
      }
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const gebruikerAanpassen = function ({ dispatch, commit }, payload) {
  const data = {};
  data.url = "edit-user-from-settings/" + payload.id;
  data.method = "POST";
  data.loading = "gebruikerAanpassen";
  data.data = payload;
  return dispatch("axiosApi", data, { root: true })
    .then((response) => {
      commit("setUser", response.data);
      return Promise.resolve(response);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
